import { useEffect, useMemo, useRef, useState } from 'react'
import { useParams } from 'react-router'
import { BillInfo } from '../components/BillInfo'
import { LifecycleSection } from '../components/lifecycle/LifecycleSection'
import { BillContext, useAppData } from '../data'
import { fetchBill } from '../fetch'
import { NotFoundPage } from './NotFoundPage'

export function ProyectoPage() {
  const app = useAppData()
  const { boletin } = useParams<{ boletin: string }>()
  const [billNotFound, setBillNotFound] = useState(false)
  const requestedBoletin = useRef<string | null>(null)
  // Keep a ref so the effect can read the latest app value without listing it
  // as a dependency — mirrors the Leptos effect that only tracks the boletin.
  const appRef = useRef(app)
  appRef.current = app

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!boletin) return
    appRef.current.triggerVotes()
    setBillNotFound(false)
    if (appRef.current.cachedBill(boletin)) {
      requestedBoletin.current = boletin
      return
    }
    if (requestedBoletin.current === boletin) return
    requestedBoletin.current = boletin
    fetchBill(boletin)
      .then((bill) => { appRef.current.cacheBill(bill); setBillNotFound(false) })
      .catch(() => setBillNotFound(true))
  }, [boletin])

  const billContext = useMemo(() => ({ selectedBoletin: boletin ?? null }), [boletin])

  return (
    <BillContext.Provider value={billContext}>
      {billNotFound ? <NotFoundPage /> : (
        <div id="sec-proyectos" className="page-section active">
          <BillInfo />
          <LifecycleSection />
        </div>
      )}
    </BillContext.Provider>
  )
}
